<template>
  <div class="py-4 px-2 p-md-4">
    <a-tabs v-model:activeKey="activeKey" id="deploy-page-tabs">
      <a-tab-pane key="1" id="deploy-model-tab">
        <template #tab>
          <span> Deploy model </span>
        </template>
        <active-devices></active-devices>
      </a-tab-pane>
      <a-tab-pane key="2" id="validate-tab">
        <template #tab>
          <span> Validate </span>
        </template>
        <div style="width: 99%">
          <main-validation></main-validation>
        </div>
      </a-tab-pane>
      <a-tab-pane v-if="role == roles.support_user" key="3" id="group-validate">
        <template #tab>
          <span> Group Validate </span>
        </template>
        <video-validate-group></video-validate-group>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { InfoCircleOutlined } from '@ant-design/icons-vue';
import { notification } from 'ant-design-vue';
import { roles } from 'src/config/roles-config';
import {
  computed,
  defineComponent,
  h,
  inject,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import ActiveDevices from './ActiveDevices.vue';
import MainValidation from './MainValidation.vue';
import VideoValidateGroup from './VideoValidateGroup.vue';

export default defineComponent({
  components: {
    MainValidation,
    ActiveDevices,
    VideoValidateGroup,
  },
  setup() {
    const store = useStore(); // Use useStore inside setup
    const role = computed(() => store.getters.role);
    const toast = inject('toast');
    onMounted(() => {
      if (store.state.devices.activeDevices.length > 0) return;

      setTimeout(
        toast.info,
        500,
        'We are looking for active devices in your organization. This will take a few seconds.',
        {
          icon: () => h(InfoCircleOutlined),
        },
        'Looking for Device(s)'
      );
    });

    onBeforeUnmount(notification.destroy);
    return {
      activeKey: ref('1'),
      role,
      roles,
    };
  },
});
</script>
<style></style>
